// extracted by mini-css-extract-plugin
export default {"cards":"PostCards_cards__eSchp"};